import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingImageDenoiserConfig } from '@/data/landingConfig/landingImageDenoiserConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_ImageDenoiser } from './schemaObject';

const ImageDenoiser = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_ImageDenoiser} />
			<LandingTemplate
				data={landingImageDenoiserConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageEnhancementV2()}
			/>
		</>
	);
};

export default ImageDenoiser;
